import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import {
  LocationTypeMovementCondition,
  defaultLocationTypeMovementCondition,
} from "types/locationManagement/locationTypeMovementCondition";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";

export async function loader({ params }: { params: Record<string, string | undefined> }) {
  let condition = defaultLocationTypeMovementCondition;
  if (params.locationTypeMovementConditionId) {
    const res = await fetcher<LocationTypeMovementCondition>(
      `/location_management/location_type_movement_conditions/${params.locationTypeMovementConditionId}`,
    );
    condition = res;
  }
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { condition, locationTypes };
}

export async function action({ request, params }: { request: Request; params: Record<string, string | undefined> }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/location_type_movement_conditions/${params.locationTypeMovementConditionId}`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/location-type-movement-conditions");
  }
  return res;
}
